/*
 * @Description: 页面埋点映射
 * @Date: 2023-11-16 15:26:35
 * @Author: mazexin
 * @LastEditors: mazexin
 */

export const aPageConfig = [
  {
    pathReg: /^\/home\/?$/i,
    monitorModule: '/home',
    monitorModuleName: 'OpenAPI首页',
    documentTitle: 'Kuaizi筷子科技 - 企业级AIGC创意智能生产和协作增长平台'
  }
]

export const getOPageConfig = () => {
  // hash模式
  let pathname = ''
  try {
    pathname = window.location.hash.match(/(^#)(.*?)((\?.*)?$)/)[2]
  } catch (error) {
    console.log(error)
  }
  // 历史记录模式
  // const pathname = window.location.pathname
  let obj = null
  for (let i = 0, len = aPageConfig.length; i < len; i++) {
    const item = aPageConfig[i]
    const reg = item.pathReg
    if (reg.test(pathname)) {
      obj = aPageConfig[i]
      break
    }
  }
  return obj
}
